import { render, staticRenderFns } from "./IconInformation.vue?vue&type=template&id=43a89c98&functional=true&"
import script from "./IconInformation.vue?vue&type=script&lang=js&"
export * from "./IconInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports